import { HorizontalFeatureSection } from '@cxc/react-hydro-components';
import styles from './style.module.scss';
import { useAtom } from 'jotai';
import { aemContent } from '../state/globalState';
import { htmlReactParserWrapper } from '../utils/htmlReactParserWrapper';
import environment from '../environment';
import { constructDigitalData, fireAnalyticsEvent } from '../analytics/analytics';
import { ESWITCH_PAGE_SCROLL_ONCLICKS_LEARN_MORE, GLOBAL_INTERACTION, PAGE_NAME } from '../analytics/analyticsConstants';
import { useUniversalContext } from '@cxc/react-universal-components';
import { AnalyticsConstants } from '../utils/constants';

export default function InfoSection() {
    const [aem]: any = useAtom(aemContent);
    const title = htmlReactParserWrapper(aem?.['section-0']?.['props']?.['heading'] || null);
    const heading = htmlReactParserWrapper(aem?.['image-section-1']?.['props']?.['heading'] || null);
    const bodyText = htmlReactParserWrapper(aem?.['image-section-1']?.['props']?.['subHeading'] || null);
    const buttonLabel = htmlReactParserWrapper(aem?.['image-section-1']?.['props']?.['ctaText'] || null);
    const buttonAriaLabel = aem?.['image-section-1']?.['props']?.['ctaAriaLabel'] || undefined;
    const imageUrl = htmlReactParserWrapper(aem?.['image-section-1']?.['props']?.['image'] || null);
    const imageAltText = aem?.['image-section-1']?.['props']?.['imageAltText'] || 'Feature image';
    const { isLoggedIn, subscribeScopedValue } = useUniversalContext();
    const cookiePreferences = subscribeScopedValue(AnalyticsConstants.FPG_COOKIES, AnalyticsConstants.COOKIE_PREFERENCES);

    const handleClick = (title: string) => {
        const digitalData = constructDigitalData(title, PAGE_NAME, GLOBAL_INTERACTION, '', '', ESWITCH_PAGE_SCROLL_ONCLICKS_LEARN_MORE, isLoggedIn, cookiePreferences);
        fireAnalyticsEvent(digitalData.digitalData, digitalData.directCallName);

        document.getElementById('comparison-table')?.scrollIntoView({ behavior: 'smooth' });
    };

    return (
        <div className={`${styles.mrgTop80}`}>
            <div className={`fds-layout-grid`}>
                <div className="fds-layout-grid__inner">
                    <div className="fds-layout-grid__cell--span-12">
                        <h3 className={`${styles.mainInfoTitle} ${styles.padLeft40}`}>{title}</h3>
                    </div>
                </div>
                <div className={`${styles.mrgTop80} ${styles.mainInfoHeading}  "fds-layout-grid__cell--span-12"`}>
                    <HorizontalFeatureSection
                        bodyText={bodyText}
                        buttons={[
                            {
                                style: 'standard',
                                title: `${buttonLabel}`,
                                onClick: () => {
                                    handleClick(`${buttonLabel}`);
                                },
                                ariaLabel: buttonAriaLabel,
                            },
                        ]}
                        className=""
                        disclosureBody=""
                        disclosureTitle=""
                        headingText={heading}
                        image={environment.AEM_URL + imageUrl}
                        imageAltText={imageAltText}
                        mediaAlignment="right"
                        videoButtonTitle=""
                        videoThumbnailIconSrc=""
                        videoThumbnailSrc=""
                    />
                </div>
            </div>
        </div>
    );
}
